export default "__VITE_ASSET__DRFM5lWR__"